import { put, takeLatest, call } from 'redux-saga/effects';
import { getPaginatedListSaga } from '../../../store/structures';
import { OK, CREATED } from 'http-status-codes';
import { safeResolveAsync } from '../../../utils';
import { FORM_ERROR } from 'final-form';
import * as api from '../../coupons/api';
import { types, actions } from './duck';

import { actions as allActions } from '../all/duck';
import { actions as detailsActions } from '../details/duck';
import { actions as categorizedActions } from '../categorized/duck';
import { actions as businessAction } from '../../businesses/details/duck';

// NOTE: mobile's version also dispatches to `coupons/recommended` here.
// That module isn't ported to web yet (its saga depends on RN geolocation),
// so favouriting won't sync to a "recommended" list on web until that
// module is ported — add `import { actions as recommendedActions } from
// '../recommended/duck';` and the two `put`s below when it is.

export function* markAsFavouriteSaga({ id, resolve }) {
  try {
    const response = yield call(api.markCouponAsFavourite, id);
    if (response.status === CREATED) {
      yield put(actions.toggleFavourite(id, true));
      yield put(allActions.toggleFavourite(id, true));
      yield put(detailsActions.toggleFavourite(id, true));
      yield put(categorizedActions.toggleFavourite(id, true));
      yield put(businessAction.toggleFavourite(id, true));
      yield safeResolveAsync(resolve, response.data);
    } else {
      const error = Array.isArray(response.data)
        ? response.data[0]
        : response.data.detail;
      yield safeResolveAsync(resolve, { error });
    }
  } catch (error) {
    yield safeResolveAsync(resolve, { [FORM_ERROR]: error.message });
  }
}

export function* removeFavouriteSaga({ id, resolve }) {
  try {
    const response = yield call(api.removeFavouriteCoupon, id);
    if (response.status === OK) {
      yield put(actions.toggleFavourite(id, false));
      yield put(allActions.toggleFavourite(id, false));
      yield put(detailsActions.toggleFavourite(id, false));
      yield put(categorizedActions.toggleFavourite(id, false));
      yield put(businessAction.toggleFavourite(id, false));
      yield safeResolveAsync(resolve, response.data);
    } else {
      const error = Array.isArray(response.data)
        ? response.data[0]
        : response.data.detail;
      yield safeResolveAsync(resolve, { error });
    }
  } catch (error) {
    yield safeResolveAsync(resolve, { [FORM_ERROR]: error.message });
  }
}

export function* reloadFavCouponsSaga() {
  yield put(actions.getAllFavouriteList());
}

export default function* saga() {
  yield takeLatest(
    types.GET_ALL_FAVOURITE_LIST,
    getPaginatedListSaga(actions, api.getAllFavourites),
  );
  yield takeLatest(types.MARK_AS_FAVOURITE, markAsFavouriteSaga);
  yield takeLatest(types.REMOVE_FAVOURITE, removeFavouriteSaga);
  yield takeLatest(types.RELOAD_FAVOURITES, reloadFavCouponsSaga);
}
